module.exports = __webpack_public_path__ + "static/img/sect-world-map.d7ec1b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sect-world-map.png
// module id = YgOQ
// module chunks = 3